module.exports = __webpack_public_path__ + "static/6305-woodrose-59-352f21644af2ae96195f1d2d2a3e478f.jpg";